import anime from 'animejs';
import Component, { forceArray } from 'navigation/component/Component';
import { bindEmitterMethod, bindMethod } from 'helpers/bind';
import { frameToMs } from 'helpers/easings';
import scroll from 'core/scroll';
import RowProductCard from 'sections/product/partials/RowProductCard';
import ImageZoomItem from './ImageZoomItem';
export default class ImageZoom extends Component {
    _opened = false;
    set opened(value) {
        this._opened = value;
        this.el.classList.toggle('opened', value);
    }
    get opened() {
        return this._opened;
    }
    _current = null;
    get current() {
        return this._current;
    }
    set current(value) {
        forceArray(this.modules.items).forEach((item) => {
            item.reset();
        });
        let direction;
        if (value && this._current)
            direction = value > this._current ? 1 : -1;
        this.modules.items[this._current]?.leave(direction);
        this._current = value;
        this.modules.items[this._current]?.enter(direction);
    }
    getModuleParams(el, componentConstructor) {
        return {
            ...super.getModuleParams(el, componentConstructor),
            parent: this.parent
        };
    }
    getModulesMap() {
        return {
            items: ['.image-zoom__item', ImageZoomItem],
            cards: ['.row-product-card', RowProductCard]
        };
    }
    bindEvents(add) {
        const method = bindMethod(add);
        const emitterMethod = bindEmitterMethod(add);
        this.refs.close[method]('click', () => this.close());
        forceArray(this.modules.items).forEach((item) => {
            item[emitterMethod]('item:enter', (header) => this.updateHeader(header));
        });
        this.refs.prev[method]('click', () => this.prev());
        this.refs.next[method]('click', () => this.next());
        this.refs.close[method]('click', () => this.close());
        this.modules.items.forEach((item, i) => {
            item[emitterMethod]('item:toggle-nav', (value) => this.onToggleNav(value));
        });
        document[method]('keydown', this.onKeydown);
    }
    updateHeader(header) {
        this.refs.header.textContent = header;
    }
    onToggleNav = (value) => {
        this.el.classList.toggle('nav-hidden', value);
    };
    onKeydown = (e) => {
        switch (e.key) {
            case 'ArrowLeft':
                this.prev();
                break;
            case 'ArrowRight':
                this.next();
                break;
            case 'Escape':
                this.close();
                break;
        }
    };
    open(index) {
        this.current = index;
        this.opened = true;
        scroll.lock();
        anime({
            targets: [this.el],
            opacity: [0, 1],
            duration: frameToMs(25),
            easing: 'linear'
        });
    }
    next() {
        this.current = (this.current + 1) % this.modules.items.length;
    }
    prev() {
        this.current = (this.current - 1 + this.modules.items.length) % this.modules.items.length;
    }
    close() {
        anime({
            targets: [this.el],
            opacity: [1, 0],
            duration: frameToMs(10),
            easing: 'linear',
            begin: () => {
                scroll.unlock();
            },
            complete: () => {
                this.opened = false;
                this.current = null;
            }
        });
    }
}
